import { render, staticRenderFns } from "./IconFarm.vue?vue&type=template&id=20ad45f8&"
import script from "./IconFarm.vue?vue&type=script&lang=ts&"
export * from "./IconFarm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports